export const GALLERY_ADDRESS_BLOCK_TEST_ID = 'galleryAddress';
